import {
  useQuery,
  ExtractFnReturnType,
  QueryConfigType,
  UseQueryResult,
} from "~/libs";

import { ApiClient } from "~/utils";

import {
  ApiKpiBusinessSectionsKpiTermsDashboardShowRequestType,
  ApiKpiBusinessSectionsKpiTermsDashboardShowResponseType,
} from "~/domains";

type RequestDataType = {
  businessSectionId: string;
  params: ApiKpiBusinessSectionsKpiTermsDashboardShowRequestType;
};

const request = async ({
  businessSectionId,
  params,
}: RequestDataType): Promise<ApiKpiBusinessSectionsKpiTermsDashboardShowResponseType> => {
  const response =
    await new ApiClient().get<ApiKpiBusinessSectionsKpiTermsDashboardShowResponseType>(
      `/api/members/kpi/business_sections/${businessSectionId}/dashboard`,
      params,
    );
  return response.data;
};

type QueryFnType = typeof request;

type PropsType = {
  businessSectionId: string;
  params: ApiKpiBusinessSectionsKpiTermsDashboardShowRequestType;
  config?: QueryConfigType<QueryFnType>;
};

export const useApisMembersKpiBusinessSectionsDashboardsShow = ({
  businessSectionId,
  params,
  config = {},
}: PropsType): UseQueryResult<ApiKpiBusinessSectionsKpiTermsDashboardShowResponseType> => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: [
      "ApisMembersKpiBusinessSectionsDashboardsShow",
      businessSectionId,
      params,
    ],
    queryFn: () => request({ businessSectionId, params }),
  });
};
